<template>
  <div class="agreement-page">
    <header>
      <h1>【养只啵啵鼻】用户协议</h1>
    </header>

    <main>
      <section v-for="(sec,idx) in userAgreement" :key="idx">
        <h3>{{sec.title}}</h3>
        <div v-html="sec.content"></div>
      </section>
    </main>

    <footer>
      <p>© 2025 上海万愈科技有限公司 版权所有</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: "UserAgreement",
  data() {
    return {
      userAgreement: [
        {
          title: "1. 特别提示",
          content: `1.1 「养只啵啵鼻」运营方上海万愈科技有限公司（以下简称“我们”）依据本协议提供虚拟宠物啵啵鼻养成服务。用户（以下简称“您”）需在认真阅读并独立思考的基础上认可、同意本协议全部条款并完成注册。点击“同意”或实际使用服务即视为接受本协议。<br>
1.2 您注册成功后同意：<br>
您需要妥善保管账号及密码。<br>
未经我们同意，禁止您买卖、转让、出租账号或宠物昵称。<br>
您对通过【养只啵啵鼻】发布的内容及后果承担全责。<br>
您可以通过设置功能，自行确认、控制您在使用【养只啵啵鼻】提交、发布或显示的信息公开方式以及可见范围<br>
1.3 您对在使用【养只啵啵鼻】过程中、对于自身的行为以及发布内容的享有合法权利，并承担相应的法律责任。同时，您同意：：<br>
授予我们全球性、非独占的内容使用权。即我们可以对您在【养只啵啵鼻】上已发布的信息，包含文字、图片、视频、音频等享有使用权。<br>
禁止以自动化手段非法抓取【养只啵啵鼻】中的内容和信息，例如宠物数据、互动记录、灵感包信息等内容。<br>
1.4 为提高您使用[养只啵啵鼻】时的感受和满意度，您同意我们可以对您数据进行调查研究和分析，从而进一步优化我们的服务。<br>
1.5 如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人(以下简称&quot;监护人&quot;)的陪同下阅读和判断是否同意本协议，并特别注意未成年人使用条款。如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和/或所处国家或地区的法律。<br>
1.6 虚拟宠物免责声明：<br>
应用内宠物行为及互动建议均为算法生成，不构成现实生活指导。涉及健康、医疗、投资等领域的操作，请以专业机构意见为准。切勿模仿危险行为。<br>
1.7 原子任务以及灵感包、灵感词免责声明：<br>
应用内提供的原子任务、灵感包、灵感词以及其他任务建议仅供应用内娱乐用途使用，不构成现实生活指导。涉及健康、医疗、投资等领域的操作，请以专业机构意见为准。切勿模仿危险行为。<br>
1.8 为提升您对于【养只啵啵鼻】的使用体验，您允许我们对您数据进行调查研究和分析，从而进一步优化服务。`,
        },
        {
          title: "2. 服务内容",
          content: `2.1 【养只啵啵鼻】服务的具体内容由我们根据实际情况提供，包括但不限于：虚拟宠物养成、社交互动、任务挑战等功能，但我们有权对提供的服务或产品形态进行升级或其他调整，并将及时更新页面/告知您。<br>
2.2我们提供的部分【养只啵啵鼻】服务为收费服务，您使用收费服务需要向我们支付一定的费用。对于收费的服务，我们会在您使用之前给予您明确的提示，只有您根据提示确认其愿意支付相关费用，您才能使用该服务。如您拒绝支付相关费用，则我们有权不向您提供该收费服务。<br>
2.3您理解，我们仅提供与“养只啵啵鼻”服务相关的技术服务，除此之外与相关网络服务有关的设备(如个人电脑、手机、及其他与接入互联网或移动网有关的装置)及所需的费用(如为接入互联网而支付的电话费及上网费、为使用移动网络而支付的手机费)均由您自行负担。我们保留调整服务的权利。`,
        },
        {
          title: "3. 服务变更、中断或终止",
          content: `3.1鉴于网络服务的特殊性(包括但不限于服务器的稳定性问题、恶意的网络攻击等行为的存在及其他我们无法控制的情形)，您同意我们有权随时中断或终止部分或全部的“养只啵啵鼻”服务(包括收费服务)，若发生该等情形，我们将尽可能及时通过网页公告、系统通知、私信、短信提醒或其他合理方式通知受到影响的您。<br>
3.2您理解，我们需要定期或不定期地对提供【养只啵啵鼻】服务的平台(如互联网网站、应用程序等)或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，我们无需为此承担任何责任，但我们应尽可能事先进行通告。<br>
3.3如发生下列任何一种情形，我们有权随时中断或终止向您提供本协议项下的【养只啵啵鼻】服务(包括收费服务和免费服务)而无需对您或任何第三方承担任何责任，由此造成的损失由您自行独立承担:<br>
您提供的个人资料不真实;<br>
您违反法律法规国家政策或本协议中规定的使用规则;<br>
您在使用收费服务时未按规定为其所使用的收费服务支付相关服务费用;<br>
您侵犯个人、企业事业单位或社会团体的合法权益，包括但不限于专利权、著作权、商标权，或姓名权、名称权、名誉权、荣誉权、肖像权、隐私权等;<br>
您损害监管部门、国家机关及政府形象;<br>
您以任何方式损害我们及其关联公司的商誉或信誉等合法权益;<br>
我们有其他合理理由认为需要中断或终止向您提供【养只啵啵鼻】服务的。<br>
3.4 您选择将“养只啵啵鼻”账号与我们合作的第三方账号进行绑定的，除您自行解除绑定关系外，如发生下列任何一种情形，您已绑定的第三方账号也有可能被解除绑定，我们无需对您或任何第三方承担任何责任:<br>
您违反法律法规国家政策、本协议的;<br>
您违反第三方您协议或其相关规定的;<br>
第三方账号所属的站方要求解除绑定的;<br>
第三方账号所属平台或业务已关停的;<br>
依据法律法规国家政策规定或主管部门要求的。`,
        },
        {
          title: "4. 使用规则",
          content: `4.1您可自行编辑注册信息中的账号名称、昵称、头像、简介等(以下简称“账号信息”)，但应遵守相关法律法规，不得含有违法和不良信息。您注册【养只啵啵鼻】账号，制作、发布、传播信息内容的，应当使用真实身份信息及个人资料，不得以虚假或冒用的居民身份信息、企业相关信息进行注册;若您的个人资料有任何变动，您应及时更新。未经相关权利人授权，您不得以他人或其他组织机构名义注册【养只啵啵鼻】账号，亦不得使用引人误解的信息注册【养只啵啵鼻】账号，包括但不限于让人误认为该账号与其他个人或机构组织存在关联关系的名称、头像或简介等。<br>
4.2您知悉并同意，以下信息一经您提交确认则无法更改，因内容瑕疵(包括但不限于错误，不完整、不满意等)所造成的损失及后果由您独立承担:<br>
账号个性域名;<br>
我们规定的确定后无法修改的账号信息。<br>
我们将建立健全您信息安全管理制度、落实技术安全防控措施。我们将对您使用【养只啵啵鼻】过程中涉及的您隐私内容加以保护。<br>
对于您在【养只啵啵鼻】中发表或存储的内容，我们建议您自行不定期备份。您理解并同意，如您通过使用注销账号功能而主动停止使用【养只啵啵鼻】服务或【养只啵啵鼻】服务被终止或取消的，我们无法向您返还或提供任何数据<br>
4.3为维护【养只啵啵鼻】平台的稳定运营，确保您体验质量，未经我们事先书面许可，任何人不得擅自在【养只啵啵鼻】平台上实施自动化行为，即未经我们同意，您自行或授权、协助第三方采用自动化手段或明显异于常人的、远高于正常您频率地对话、评论、打招呼、参与话题讨论或做出关注、点赞、抓取数据等的行为。<br>
4.4您不得在【养只啵啵鼻】平台上发布垃圾信息，即未经我们同意，擅自使用【养只啵啵鼻】账号在【养只啵啵鼻】的公告平台、共创活动、好友社交等功能或内容中发布的营销信息、无意义信息或买卖粉丝信息。<br>
4.5您同意我们在提供【养只啵啵鼻】服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息(包括但不限于在【养只啵啵鼻】平台网站的任何页面上投放广告)，并且，您同意接受我们通过电子邮件、私信或其他方式向您发送商品促销或其他相关商业信息。<br>
4.6为了更好地促进信息分享及宣传推广，您授权我们可在【养只啵啵鼻】及其关联产品和服务上使用【养只啵啵鼻】内容，以及为宣传推广之目的将上述内容许可给第三方使用。您对我们及其关联公司的前述授权并不改变您发布内容的所有权及知识产权归属，也并不影响您行使其对发布内容的合法权利。<br>
4.7您在使用【养只啵啵鼻】服务的过程中应文明发言，并依法尊重其它您的人格权与身份权等人身权利，共同建立和谐、文明、礼貌的网络社交环境。<br>
4.8您在使用【养只啵啵鼻】服务过程中，必须遵循以下原则:<br>
不得违反中华人民共和国法律法规及相关国际条约或规则;<br>
不得违反与网络服务、【养只啵啵鼻】服务有关的网络协议、规定、程序及行业规则;<br>
不得进行任何可能对互联网或移动网正常运转造成不利影响的行为;<br>
不得上传、展示或传播任何不实虚假、冒充性的、骚扰性的、中伤性的、攻击性的、辱骂性的、恐吓性的、种族歧视性的、诽谤诋毁、泄露隐私、色情淫秽、恶意抄袭、暴力、血腥、自杀、自残的或其他任何非法的信息资料;<br>
不得侵犯任何个人、企业事业单位或社会团队的合法权益，包括但不限于专利权、著作权、名称权、名誉权、荣誉权、肖像权、隐私权等;<br>
不得以任何方式损害各级国家机关及政府形象;<br>
不得以任何方式损害我们及其关联公司的商誉或信誉等合法权益;<br>
不得从事其他任何影响我们正常运营、破坏【养只啵啵鼻】经营模式或其他有害【养只啵啵鼻】生态的行为;<br>
得为其他任何非法目的而使用【养只啵啵鼻】服务。<br>
4.9针对某些特定的【养只啵啵鼻】服务的使用规则及说明，我们通过各种方式(包括但不限于网页公告、系统通知、私信、短信提醒等)作出的任何声明、通知、警示等内容均视为本协议的一部分，您如使用该等【养只啵啵鼻】服务，视为您同意该等声明、通知、警示的内容。<br>
4.10我们有权对您使用【养只啵啵鼻】服务的行为及信息进行审查、监督及处理，包括但不限于您的信息(账号信息、个人信息等)、发布内容(位置、文字、图片、音频、视频、商标、专利、出版物等)、您行为(构建关系、@信息、评论、私信、参与话题、参与活动、营销信息发布、举报投诉等)等范畴。`,
        },
        {
          title: "5. 知识产权",
          content: `5.1我们是【养只啵啵鼻】平台和【养只啵啵鼻】产品的所有权及知识产权权利人。<br>
5.2我们是【养只啵啵鼻】平台及【养只啵啵鼻】产品中所有信息内容的所有权及知识产权权利人。前述信息内容包括但不限于程序代码、界面设计、版面框架、数据资料、账号、文字、图片、图形、图表、音频、视频等，除按照法律法规规定应由相关权利人享有权利的内容以外。<br>
5.3您在使用【养只啵啵鼻】的过程中，可能会使用到由第三方开发的在【养只啵啵鼻】平台运行的功能、软件或服务，您除遵守本协议相关规定以外，还应遵守第三方相关规定，并尊重第三方权利人对其功能、软件、服务及其所包含内容的相关权利。<br>
5.4鉴于以上，您理解并同意:<br>
未经我们及相关权利人同意，您不得对上述功能、软件、服务进行反向工程(reverseengineer)、反向编译(decompile)或反汇编(disassemble)等;同时，不得将上述内容或资料在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者用于其他任何目的;<br>
在尽商业上的合理努力的前提下，我们并不就上述功能、软件、服务及其所包含内容的延误、不准确、错误、遗漏或由此产生的任何损害，以任何形式向您或任何第三方承担任何责任;<br>
我们并不对上述任何由第三方提供的功能、软件、服务或内容进行任何保证性的、或连带性的承诺或担保，由此产生的任何纠纷、争议或损害，由您与第三方自行解决，我们不承担任何责任;<br>
为更好地维护【养只啵啵鼻】生态，我们保留在任何时间内以任何方式处置上述由我们享受所有权及知识产权的产品或内容，包括但不限于修订、屏蔽、删除或其他任何法律法规允许的处置方式。`,
        },
        {
          title: "6.隐私保护",
          content: `6.1保护您隐私和其他个人信息是【养只啵啵鼻】的一项基本政策，具体内容详见【养只啵啵鼻】个人信息相关保护政策。`,
        },
        {
          title: "7.免责声明",
          content: `7.1您在使用【养只啵啵鼻】过程中应遵守国家法律法规及政策规定，因其使用【养只啵啵鼻】而产生的行为后果由您自行承担。<br>
7.2您通过【养只啵啵鼻】服务发布的任何信息，及通过【养只啵啵鼻】服务传递的任何观点不代表上海万愈科技有限公司之立场，上海万愈科技有限公司亦不对其完整性、真实性、准确性或可靠性负责。您对于可能会在【养只啵啵鼻】上接触到的非法的、非道德的、错误的或存在其他失宜之处的信息，及被错误归类或是带有欺骗性的发布内容，应自行做出判断。在任何情况下，因前述非正当信息而导致的任何损失或伤害，应由相关行为主体承担全部责任。<br>
7.3鉴于外部链接指向的网页内容非我们实际控制，因此我们无法保证为向您提供便利而设置的外部链接的准确性和完整性。<br>
7.4对于因不可抗力或我们不能控制的原因造成的【养只啵啵鼻】服务中断或其它缺陷，我们不承担任何责任，但我们将尽力减少因此而给您造成的损失和影响。<br>
7.5我们对其向您所提供的【养只啵啵鼻】产品及服务依法承担相关责任，但法律另有规定或另有约定的除外。<br>
7.6您知悉并同意，我们可能会与第三方合作向您提供产品(包括但不限于游戏、第三方应用等)并由第三方向您提供该产品的升级、维护、客服等后续工作，由该等第三方对该产品的质量问题或其本身的原因导致的一切纠纷或您损失承担责任，您在此同意将向该第三方主张与此有关的一切权利和损失。<br>
7.7除另有约定外，我们提供的产品或服务(包括但不限于互动物品及道具)，如未标明使用期限、或者其标明的使用期限为“永久”、“无限期”或“无限制”的，则其使用期限为自您开始使用该产品或服务至该产品或服务在【养只啵啵鼻】下线之日为止。`,
        },
        {
          title: "8.违约责任",
          content: `8.1如因我们违反有关法律、法规或本协议项下的任何条款而给您造成损失的，因此给您造成的损害赔偿责任由我们承担。<br>
8.2您同意保障和维护我们及其关联公司及其他您的合法权益，如因您违反有关法律、法规或本协议项下的任何条款而给我们及其关联公司或任何其他任何第三方造成损失，您同意承担由此造成的损害赔偿责任。<br>
8.3如我们发现或收到第三方举报或投诉获知，您存在或涉嫌违反本协议第1条(特别提示)、或第4条(使用规则)的，我们或其授权主体有权依据其合理判断不经通知立即采取一切必要措施以减轻或消除您行为造成的影响，并将尽可能在处理之后对您进行通知。由此造成的损失及后果(包括但不限于错过推广时机、丧失营销收入等)由您自行独立承担。<br>
8.4除本协议另有约定外，如我们发现或收到第三方举报或投诉获知，您存在或涉嫌违反本协议中约定的义务、保证、承诺或其他条款，您应在我们指定期限内予以纠正并消除影响;若您未在前述时限内予以纠正的，我们或其授权主体有权依据其合理判断立即采取一切必要措施以减轻或消除您行为造成的影响，并将尽可能在处理之后对您进行通知。由此造成的损失及后果(包括但不限于错过推广时机、丧失营销收入等)由您自行独立承担。<br>
8.5本协议8.3、8.4中所述的“一切必要措施”包括但不限于以下一项或多项:<br>
8.5.1更改、删除或屏蔽相关内容;<br>
8.5.2警告违规账号、账号禁言;<br>
8.5.3冻结您账户资金，用于弥补您给我们及其关联公司、他人造成的损失;<br>
8.5.4变更、限制或禁止违规账号部分或全部功能;<br>
8.5.5暂停、限制或终止您使用【养只啵啵鼻】服务的权利、注销您账号等;<br>
8.5.6向有关监管部门或国家机关报告;<br>
8.5.7其他我们认为合理的措施。`,
        },
        {
          title: "9.协议修改",
          content: `9.1我们有权随时修改本协议的任何条款，一旦本协议的内容发生变动，我们将会在【养只啵啵鼻】平台上公布修改之后的协议内容，我们也可选择通过其他适当方式(比如系统通知)向您通知修改内容。<br>
9.2如果不同意我们对本协议相关条款所做的修改，您有权停止使用【养只啵啵鼻】服务。如果您继续使用【养只啵啵鼻】服务，则视为您接受我们对本协议相关条款所做的修改。`,
        },
        {
          title: "10.通知送达",
          content: `10.1本协议项下我们对于您所有的通知均可通过网页公告、电子邮件、系统通知、【养只啵啵鼻】管理账号主动联系、私信、手机短信或常规的信件传送等方式进行;该等通知于发送之日视为已送达收件人。<br>
10.2您对于我们的通知应当通过我们对外正式公布的邮件地址联系信息进行送达。请按照下列方式联系我们:在线邮箱: Lucas@wanyutec.com.cn`,
        },
        {
          title: "11.法律适用",
          content: `11.1本协议的订立、执行和解释及争议的解决均应适用中华人民共和国大陆地区法律。<br>
11.2如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决;协商不成时，任何一方均可向上海地区人民法院提起诉讼。`,
        },
        {
          title: "12.未成年人使用条款",
          content: `12.1若用户未满18周岁，则为未成年人，应在监护人监护、指导下阅读本协议和使用本服务。<br>
12.2未成年人用户涉世未深，容易被网络虚像迷惑，且好奇心强，遇事缺乏随机应变的处理能力，很容易被别有用心的人利用而又缺乏自我保护能力。因此，未成年人用户在使用本服务时应注意以下事项，提高安全意识，加强自我保护:<br>
认清网络世界与现实世界的区别，避免沉迷于网络，影响日常的学习生活。<br>
填写个人资料时，加强个人保护意识，以免不良分子对个人生活造成骚扰。<br>
在监护人或老师的指导下，学习正确使用网络。<br>
避免陌生网友随意会面或参与联谊活动，以免不法分子有机可乘，危及自身安全。<br>
监护人、学校均应对未成年人使用本服务多做引导。特别是家长应关心子女的成长，注意与子女的沟通，指导子女上网应该注意的安全问题，防患于未然。<br>
12.3已满18周岁的成年人因任何原因不具备完全民事行为能力的，参照适用本协议之未成年人使用条款之相关约<br>
定。`,
        },
        {
          title: "13.其他规定",
          content: `13.1如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。<br>
13.2本协议中的标题仅为方便而设，在解释本协议时应被忽略，不能作为本协议条款解释的依据。`,
        }
      ]
    };
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  background: #f5f7fa;
  color: #333;
}
.agreement-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 16px;
}
header {
  background: #4a5568;
  border-bottom: 1px solid #e2e8f0;
  padding: 20px 0;
  text-align: center;
}
header h1 {
  font-size: 24px;
}
main {
  background: #fff;
  border-radius: 8px;
  padding: 24px 32px;
  margin-top: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
section {
  margin-bottom: 28px;
}
section h3 {
  color: #4a5568;
  font-size: 16px;
  margin-bottom: 8px;
  font-weight: 600;
}
section div {
  font-size: 14px;
  line-height: 1.8;
  color: #4a5568;
}
footer {
  text-align: center;
  padding: 20px 0;
  font-size: 12px;
  color: #a0aec0;
}
</style>
